import React from 'react'
import Header from '../Header/Header'
import Footer from './Footer'
import './LegalMentions.css';

const LegalMentions = () => {
  return (
    <>
    <div className='Super-legal-mentions'>
        <Header/>
    <div className='Legal-mentions'>

        <h1>Mentions légales</h1>

        <h2>INFORMATIONS</h2>
        <p>Les informations contenues sur le site www.ophtarade.fr ne constituent ni directement, ni indirectement une consultation médicale. Ces informations sont destinées à améliorer et non à remplacer la relation directe entre le patient et l’ophtalmologiste. En aucun cas, ces informations sont susceptibles de se substituer à une consultation, une visite ou un diagnostic formulé par votre médecin. Vous ne devez pas mettre en oeuvre les informations disponibles sur le site pour la formulation d’un diagnostic, la détermination d’un traitement ou la prise et/ou la cessation de la prise de médicament sans consulter préalablement un ophtalmologiste. Vous reconnaissez que les informations qui sont mises à votre disposition ne sont ni complètes, ni exhaustives et que ces informations ne traitent pas de l’intégralité des différents symptômes, médicaments et traitements appropriés aux pathologies et différents maux quotidiens. Le cabinet n’est en aucun cas responsable des interprétations qui pourraient être faites des informations communiquées sur ce site.</p>

        <h2>INFORMATIONS LÉGALES</h2>
        <p>Le présent site est la propriété de la Société Centre Neurologique du Ponant.
        <br/>SCM au capital de … Euros.
        <br/>Siège social : ….
        <br/>SIRET : …
        <br/>Tél. : …
        <br/>Directrice de la publication : …</p>

        <p>Droits d’auteur et Propriété intellectuelle:</p>

        <br/>Associés de la société Centre Neurologique du Ponant.

        <p>L’accès au site www.centre-neurologique-ponant.fr vous confère un droit d’usage privé et non exclusif de ce site. Le présent site et l’ensemble des éléments qui y sont édités incluant notamment les textes, photographies, illustrations, logos, marques, … sont la propriété du Noms Prénoms gérants de d’Ophtarade – Centre ophtalmologique de la Rade au titre des législations sur les droits d’auteur et de la propriété intellectuelle. Sauf autorisation expresse des Directeurs de la publication, la modification, la reproduction, la représentation et le téléchargement de tout ou partie de ce site, sur quelque support que ce soit, pour un usage autre que privé, sont interdits.</p>

        <p>Hébergement :
        <br/>**
        <br/>**, Siège social : 2 rue Kellermann – 59100 Roubaix – France
        <br/>** adresse
        <br/>Code APE **
        <br/>N° TVA : **</p>

        <p>Conception & design du site web :
        <br/>Manon GALLE</p>


        <p>Déclaration CNIL :

        <br/>Le présent site n’a pas fait l’objet d’une déclaration CNIL conformément à la Loi Informatique et Libertés du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés qui dispense les éditeurs d’une déclaration concernant les traitements de données personnelles mis en œuvre par tout organisme privé ou public à des fins d’information et de communication externe. Elle s’applique aux sites internet institutionnels et aux fichiers de contacts. À la suite de l’entrée en application du RGPD, les dispenses adoptées par la CNIL n’ont plus de valeur juridique à compter du 25 mai 2018.</p>

        <p>Données personnelles

        <br/>Les données personnelles recueillies à partir de tout formulaire de ce site font l’objet d’un traitement informatique destiné à Noms Prénoms (gérants du centre ophtalmologique de la Rade) pour répondre aux demandes de contact ou pour envoyer une lettre d’information hebdomadaire. Conformément à la loi « informatique et libertés » du 6 janvier 1978 modifiée, vous disposez d’un droit d’accès et de rectification aux informations qui vous concernent. Vous pouvez accéder aux informations vous concernant en vous adressant à : contact@ophtarade.fr – Pour en savoir plus, consultez vos droits sur le site de la CNIL.</p>

    

    </div>
    
    </div>
    <Footer/>
    </>
  )
}

export default LegalMentions